module.exports = __webpack_public_path__ + "img/teaser_hund2.f7a453cd.jpg";